import { Box, Button, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import BlockType from 'src/enums/blockType';
import BlockDestination from './BlockDestination.tsx';
import BlockOptions from './BlockOptions.tsx';

interface AddBlockProps {
	onStageChange?: (stage: number) => void;
}

const AddBlock: React.FC<AddBlockProps> = ({ onStageChange }) => {
	const theme = useTheme();

	const [stage, setStage] = useState(0);
	const [selectedBlockType, setSelectedBlockType] = useState<BlockType>();

	useEffect(() => {
		setSelectedBlockType(undefined);
	}, []);

	useEffect(() => {
		if (onStageChange) {
			onStageChange(stage);
		}
	}, [stage, onStageChange]);

	return (
		<Box
			sx={{
				backgroundColor: theme.palette.common.white,
				boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.3)',
				borderRadius: '5px',
				minWidth: 'max-content',
			}}
		>
			{stage == 0 && (
				<Button
					sx={{
						fontWeight: 'bold',
						color: 'black',
					}}
					endIcon={<AddIcon sx={{ color: theme.palette.grey[500] }} />}
					onClick={() => setStage(1)}
				>
					Add Block
				</Button>
			)}

			{stage == 1 && (
				<BlockOptions
					theme={theme}
					setStage={setStage}
					setSelectedBlockType={setSelectedBlockType}
				/>
			)}

			{stage == 2 && (
				<BlockDestination
					theme={theme}
					setStage={setStage}
					selectedBlockType={selectedBlockType}
				/>
			)}
		</Box>
	);
};

export default AddBlock;
